<template>
  <campaign-table />
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CampaignTable from "./CampaignTable.vue";

export default {
  name: "Campaign",
  components: { CampaignTable },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}` }
    ]);
  }
};
</script>
